import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@osmix/ui/button";

// Плашка согласия на cookie (152-ФЗ / «Политика использования cookie»): в подвале
// есть PDF-политика, но нужно активное уведомление. Показываем один раз — выбор
// запоминаем в localStorage; сервер о нём не знает (баннер сугубо клиентский).
const STORAGE_KEY = "osmix-cookie-consent";
const COOKIE_POLICY_PDF = "/docs/b2c/Политика использования cookie OSMIX.pdf";
export function CookieConsent() {
  const $ = _c(19);
  const {
    t
  } = useTranslation();
  const [visible, setVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      try {
        if (!localStorage.getItem(STORAGE_KEY)) {
          setVisible(true);
        }
      } catch {}
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!visible) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      try {
        localStorage.setItem(STORAGE_KEY, new Date().toISOString());
      } catch {}
      setVisible(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const accept = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("cookie.text", {
      defaultValue: "\u041C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C cookie, \u0447\u0442\u043E\u0431\u044B \u0441\u0430\u0439\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u043B \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E \u0438 \u0443\u0434\u043E\u0431\u043D\u043E. \u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F OSMIX, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 \u0438\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C."
    });
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = encodeURI(COOKIE_POLICY_PDF);
  let t5;
  if ($[5] !== t) {
    t5 = t("cookie.policy", {
      defaultValue: "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 cookie"
    });
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <a href={t4} target="_blank" rel="noreferrer" className="whitespace-nowrap text-osmix-tangelo underline underline-offset-2 hover:text-osmix-tangelo/80">{t5}</a>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <p className="flex-1 type-body2 text-white/90">{t3}{" "}{t6}</p>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("cookie.accept", {
      defaultValue: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C"
    });
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <Button variant="osmix-filled" size="pill" className="shrink-0 self-start sm:self-auto" onClick={accept}>{t8}</Button>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 px-4 pb-4"><div className="pointer-events-auto mx-auto flex max-w-3xl flex-col gap-3 rounded-[16px] bg-osmix-text-1 p-5 text-white shadow-[0_8px_32px_rgba(0,0,0,0.18)] sm:flex-row sm:items-center sm:gap-5">{t7}{t9}</div></div>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}